import { connect } from 'react-redux'
import VolunteerEventRegisterScene from '../../scenes/volunteer-event-register'
import {
  addRegistrationLine,
  addRole,
  addShift,
  clear,
  removeRegistrationLine,
  removeShift,
  setRegistrationLineRole,
  validate,
} from '../reducers/VolunteerEventRegister'

function MSTPVolunteerEventRegister(state: any) {
  return {
    data: state.VolunteerEventRegister,
  }
}

function mapDispatchToProps(dispatch: any) {
  return {
    addRole: (shiftId: number, roleId: number) => dispatch(addRole(shiftId, roleId)),
    addShift: (shift: any) => dispatch(addShift(shift)),
    addRegistrationLine: (timeshiftId: number, lineKey: string) => dispatch(addRegistrationLine(timeshiftId, lineKey)),
    removeRegistrationLine: (lineKey: string) => dispatch(removeRegistrationLine(lineKey)),
    setRegistrationLineRole: (lineKey: string, roleId: number) => dispatch(setRegistrationLineRole(lineKey, roleId)),
    removeShift: (shiftId: any) => dispatch(removeShift(shiftId)),
    validate: () => dispatch(validate()),
    clear: () => dispatch(clear()),
  }
}

export default connect(MSTPVolunteerEventRegister, mapDispatchToProps)(VolunteerEventRegisterScene)
